(function () {
  'use strict';

  // This script is installed only on the new Theme. Shopify renders the
  // vendor's inline configuration before deferred scripts run; this head
  // script executes before the vendor's body-deferred bundle. Remove its
  // Volume offer before it registers add-to-cart interception. Keep Gift
  // and every other offer intact, including when new Volume is disabled.
  if (window._BK && Array.isArray(window._BK.entries)) {
    window._BK.entries = window._BK.entries.filter(function (entry) {
      return entry.type !== 'volume';
    });
  }

  var pending = false;

  function route(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/?$/, '/') + path;
  }

  window.addEventListener('click', function (event) {
    var target = event.target && event.target.nodeType === 1
      ? event.target
      : event.target && event.target.parentElement;
    var control = target && target.closest('.quantity .plus, .quantity .minus');
    var scope = control && control.closest('.quantity');
    var input = scope && scope.querySelector('.qty_cart_js[data-ago-volume-selected="1"]');
    if (!input) return;

    // A card-selected line may only gain selected units through another card click.
    // The ordinary cart + control creates a distinct line without the selection property.
    // Handle - here too so the refreshed cart does not show a stale tier after a drop below 3.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || control.disabled || input.hasAttribute('data-ago-flash-sales-limit')) return;

    var isPlus = control.classList.contains('plus');
    var key = input.getAttribute('data-id');
    var quantity = Number(input.value);
    var variantId = Number(input.getAttribute('data-ago-volume-variant-id'));
    if (isPlus && (!Number.isSafeInteger(variantId) || variantId <= 0)) return;
    if (!isPlus && (!key || !Number.isSafeInteger(quantity) || quantity <= 0)) return;
    pending = true;
    fetch(route(isPlus ? 'cart/add.js' : 'cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(isPlus
        ? { items: [{ id: variantId, quantity: 1 }] }
        : { id: key, quantity: quantity - 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    }).catch(function () {
      pending = false;
      window.alert('Unable to update this item. Please try again.');
    });
  }, true);
})();
